import { IColor, variantColors } from "../../../utils/selectColors";
import { Flex, Text } from "@mantine/core";

interface IProps {
  badgeName: string;
  badgeColor?: IColor;
}

export default function BadgeInstruments({
  badgeColor = IColor.babyBlue,
  badgeName,
}: IProps) {
  const selectedVariant = variantColors[badgeColor];

  return (
    <Flex
      style={{
        backgroundColor: selectedVariant.bg,
        borderRadius: "8px",
        border: "1px solid",
        borderColor: selectedVariant.color,
        padding: "4px 12px",
        width: "fit-content",
        minHeight: "40px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          color: selectedVariant.color,
          fontSize: "14px",
          lineHeight: "14px",
          textAlign: "center",
          fontWeight: 600,
          fontFamily: "barlow",
          textTransform: "uppercase",
        }}
      >
        {badgeName}
      </Text>
    </Flex>
  );
}
